/**
 * @generated SignedSource<<7647244f80d98988d8c2d81ce044b60e>>
 * @relayHash 5f11b5c81c70d4e33350451601be66a2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8164c112273ebbcb1d33bd48c77e8415188a807f78047eb8accb0297b024f383

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ListQuery } from './ListQuery.graphql';

import isInitialiseVirtualiserStateFromRelayStoreEnabled_provider from '@atlassian/jira-relay-provider/src/initialise-virtualiser-state-from-relay-store.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isSingleLineEventDelegatorEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-event-delegator-enabled.relayprovider';
import isJiraSingleLineRowHeightEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-row-height-enabled.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isIssueRealtimeExtractionEnabled_provider from '@atlassian/jira-relay-provider/src/jira-issue-realtime-extraction.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isJiraTimelineAnalyticsHarmonizationEnabled_provider from '@atlassian/jira-relay-provider/src/jira-timeline-analytics-harmonization.relayprovider';
import isQueryByStatusFieldDirectlyEnabled_provider from '@atlassian/jira-relay-provider/src/jiv-20953-query-by-status-field-directly.relayprovider';
import isJSCAliasChangesEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-alias-changes.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';

const node: PreloadableConcreteRequest<ListQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8164c112273ebbcb1d33bd48c77e8415188a807f78047eb8accb0297b024f383",
    "metadata": {},
    "name": "ListQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraissuerealtimeextractionrelayprovider": isIssueRealtimeExtractionEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcinitialisevirtualiserstatefromrelaystorerelayprovider": isInitialiseVirtualiserStateFromRelayStoreEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": isQueryByStatusFieldDirectlyEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiratimelineanalyticsharmonizationrelayprovider": isJiraTimelineAnalyticsHarmonizationEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelineeventdelegatorenabledrelayprovider": isSingleLineEventDelegatorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider
    }
  }
};

export default node;
